import React, { useState,useEffect } from "react";
import Userlist from "./rederdata";
import { toast } from "react-toastify";
import Select from "../common/selectcustom1";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const Imagelist = ({
  isOpen,
  header,
  onCancel,onConfirm,
  message,
  list,
  id,
  typelist,
  size = "xl",
}) => {
  let extension = "";
  const [formData, setFormData] = useState({});
  const [messageError, setmessageError] = useState({
    imagetypeid: "",
  });











  const handleSelectChange = (inputKey, data) => {
    if (!data) return;
      setFormData({
        ...formData,
        [inputKey]: JSON.parse(data),
      });
      if (JSON.parse(data) !== 0) {
        setmessageError({ ...messageError, [inputKey]: "" });
      }  
  };

  return (
   

      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>{header}</ModalHeader>
        <ModalBody>


          {list && list.length > 0 && <Userlist list={list}  >  </Userlist>}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
 
  );
};

export default Imagelist;
